import classNames from 'classnames'

type CourseFilterChipProps = {
  label: string
  count: number
  onClick: () => void
}

const CourseFilterChip = ({ label, count, onClick }: CourseFilterChipProps) => {
  const hasSelection = count > 0

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        'inline-flex items-center gap-1 sm:gap-2 px-2 py-1 rounded border text-sm font-500 focus:outline-none transition-colors whitespace-no-wrap leading-tight border-orange',
        hasSelection
          ? 'bg-orange-200 text-orange font-600'
          : 'hover:bg-orange-200'
      )}
    >
      <span>{label}</span>
      {hasSelection && (
        <span className="inline-flex items-center justify-center rounded-full bg-orange text-white leading-none h-3 w-3 sm:h-4 sm:w-4 text-xxs sm:text-xs font-600">
          {count}
        </span>
      )}
    </button>
  )
}

export default CourseFilterChip
